import { render, staticRenderFns } from "./AddOrigin.vue?vue&type=template&id=9364493c&scoped=true"
import script from "./AddOrigin.vue?vue&type=script&lang=js"
export * from "./AddOrigin.vue?vue&type=script&lang=js"
import style0 from "./AddOrigin.vue?vue&type=style&index=0&id=9364493c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9364493c",
  null
  
)

export default component.exports